import { HttpStatusCode } from "axios";

import {
  AUDIT_LOG_AREA_NAME_ENTITIES,
  buildDropdownLabelByIdMap,
  Log,
  type ApiException,
  type IDropdownItem,
  type RydeUiUnit,
} from "@ryde/shared";

/**
 * Area names for a history that shows area ids. Any other entity skips the request, and a refused one (a role
 * without access to areas) leaves the ids unnamed instead of failing the whole history. An expired session is
 * passed on, so the history's own handling sends the user to log in again.
 */
export const loadAuditLogAreaNames = async ({
  entity,
  getDropdownItems,
}: {
  entity: RydeUiUnit;
  getDropdownItems?: (entity: RydeUiUnit) => Promise<IDropdownItem[]>;
}): Promise<Map<number, string>> => {
  if (!AUDIT_LOG_AREA_NAME_ENTITIES.has(entity) || !getDropdownItems) {
    return new Map();
  }

  try {
    return buildDropdownLabelByIdMap(await getDropdownItems("area"));
  } catch (error) {
    if ((error as ApiException)?.statusCode === HttpStatusCode.Unauthorized) {
      throw error;
    }
    Log.warn("Audit log area names could not be loaded", error);
    return new Map();
  }
};
